module.exports = __webpack_public_path__ + "static/media/chevronleft.bebec14d.svg";